export default "__VITE_ASSET__Dqhifmy4__"